module.exports = __webpack_public_path__ + "static/media/tick-blanco-icn.c4a547fc.svg";